export const POPOVER_PARTS = [
  'popper',
  'content',
  'header',
  'body',
  'footer',
  'arrow',
  'overlay',
] as const;
